module.exports = __webpack_public_path__ + "img/zhuangshi@3x.0e451550.svg";